// extracted by mini-css-extract-plugin
export default {"GreyDivider":"divider_GreyDivider__df3Tr"};